function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73885 1.65526C8.89362 1.60374 9.05805 1.58795 9.21979 1.60906C9.38154 1.63018 9.5364 1.68765 9.67276 1.77717C9.80912 1.86669 9.92344 1.98593 10.0071 2.12595C10.0908 2.26596 10.1417 2.42311 10.156 2.58561L10.1603 2.68066V6.63101L12.8923 7.17827C13.1199 7.22365 13.3269 7.34116 13.4826 7.5134C13.6382 7.68565 13.7342 7.90345 13.7564 8.13454L13.7607 8.23679V13.7022H14.4808C14.6643 13.7024 14.8408 13.7727 14.9743 13.8987C15.1077 14.0247 15.1881 14.1969 15.1988 14.3801C15.2096 14.5633 15.15 14.7437 15.0322 14.8844C14.9144 15.0252 14.7473 15.1156 14.565 15.1373L14.4808 15.1424H1.51933C1.3358 15.1422 1.15927 15.0719 1.02581 14.9459C0.892354 14.8199 0.812043 14.6477 0.801287 14.4645C0.790531 14.2813 0.850142 14.1008 0.96794 13.9601C1.08574 13.8194 1.25283 13.7289 1.43508 13.7072L1.51933 13.7022H2.23941V4.60039C2.23941 4.16834 2.49576 3.78238 2.88604 3.611L2.97821 3.57571L8.73885 1.65526ZM8.72013 3.18039L3.67957 4.86034V13.7022H8.72013V3.18039ZM10.1603 8.1007V13.7022H12.3205V8.53202L10.1603 8.1007Z",
    fill: "#667085",
    style: {
      fill: "#667085",
      fill: "color(display-p3 0.4000 0.4392 0.5216)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.95952431a305ed0d89a25a742b08a6c9.svg";
export { ForwardRef as ReactComponent };